import React, { useState } from 'react';
import { Box, TextField, Button, Checkbox, FormControlLabel, Typography, Paper } from '@mui/material';
import toast from 'react-hot-toast';

const ContactUs = () => {
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    agree: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.agree) {
      toast('You must agree to the terms.');
      return;
    }
    console.log('Form submitted:', form);
    toast('Message sent! We will contact you soon.');
    setForm({
      firstName: '',
      lastName: '',
      email: '',
      message: '',
      agree: false,
    });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '20vh',
      
        padding: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 500, width: '100%', border:'none' }}>
      
        <Typography sx={{ justifyContent: 'center',
         textAlign: 'center',mb:3}} variant="h5" gutterBottom fontWeight="bold">
          Contact the Orion Team
        </Typography>
        <Typography variant="body2" gutterBottom>
          We're here to answer your questions and discuss your configuration. Let's talk!
        </Typography>
        <form onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
            <TextField
              fullWidth
              label="First Name"
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              label="Last Name"
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              required
            />
          </Box>
          <TextField
            fullWidth
            label="Email Address"
            name="email"
            value={form.email}
            onChange={handleChange}
            type="email"
            required
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth
            label="Message"
            name="message"
            value={form.message}
            onChange={handleChange}
            multiline
            rows={4}
            required
            sx={{ mb: 2 }}
          />
          <FormControlLabel
            control={<Checkbox checked={form.agree} onChange={handleChange} name="agree" />}
            label="I agree to the terms of use and privacy policy."
            sx={{ mb: 2 }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              background: 'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)',
              color: '#fff',
              fontWeight: 700,
              padding: '10px 0',
              '&:hover': { background: 'linear-gradient(45deg, #1BB2F8 0%, #2b8cb9 51%, #064D6F 100%)' },
            }}
          >
            Submit
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default ContactUs;
